import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

/**
 * Resets scroll on navigation.
 *
 * Uses "instant" rather than the smooth behaviour set globally on <html>:
 * animating the scroll on a route change means the visitor watches the old
 * page fly past before the new one appears. In-page anchors still get smooth
 * scrolling. A hash in the URL is left alone so deep links keep working.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
};

/**
 * The public site frame.
 *
 * `<main>` carries no top padding on purpose: the header is fixed and every
 * public page opens with a full-bleed ink band that it sits over. Pages own
 * their own header clearance via the hero component.
 */
const SiteLayout = ({ children }) => (
  <>
    <ScrollToTop />
    <SiteHeader />
    <Box component="main" id="main" sx={{ display: "block" }}>
      {children}
    </Box>
    <SiteFooter />
  </>
);

export default SiteLayout;
